'use client';

import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/navigation';
import { useMemo } from 'react';
import { ROUTES, STORAGE_KEY } from '@/constants';
import { requestCloseResponsiveDialog } from '@/stores/DrawerStore';
import { useHistoryStore } from '@/stores/HistoryStore/useHistoryStore';
const NOT_ALLOW_BACK_ROUTE = [ROUTES.AUTH, ROUTES.EASY_CERTIFICATION, ROUTES.EASY_CERTIFICATION_CALLBACK, ROUTES.LOGIN, ROUTES.CROSS_DOMAIN_AUTH];
export const useCustomRouter = () => {
  const $ = _c(11);
  const router = useRouter();
  let push;
  let t0;
  if ($[0] !== router) {
    push = (href, options) => router.push(href, options);
    t0 = (href_0, options_0) => {
      sessionStorage.setItem(STORAGE_KEY.REPLACE_MARK_KB, "true");
      return router.replace(href_0, options_0);
    };
    $[0] = router;
    $[1] = push;
    $[2] = t0;
  } else {
    push = $[1];
    t0 = $[2];
  }
  const replace = t0;
  let t1;
  if ($[3] !== replace || $[4] !== router) {
    t1 = () => {
      if (requestCloseResponsiveDialog()) {
        return;
      }
      const {
        historyIndex,
        customHistory
      } = useHistoryStore.getState();
      const isEmptyHistory = historyIndex < 1;
      const prevHistoryPath = customHistory.get(historyIndex - 1);
      const isNotAllowBackRoute = prevHistoryPath ? NOT_ALLOW_BACK_ROUTE.some(route => prevHistoryPath.includes(route.pathname)) : true;
      if (isEmptyHistory || isNotAllowBackRoute) {
        return replace(ROUTES.HOME.pathname);
      }
      return router.back();
    };
    $[3] = replace;
    $[4] = router;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const back = t1;
  let t2;
  if ($[6] !== back || $[7] !== push || $[8] !== replace || $[9] !== router) {
    t2 = {
      ...router,
      push,
      replace,
      back
    };
    $[6] = back;
    $[7] = push;
    $[8] = replace;
    $[9] = router;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const customRouter = t2;
  return customRouter;
};